export type MaintenancePageTranslation = {
  defaultMessage: string;
  expectedCompletion: string;
  maintenanceWork: string;
  thankYouMessage: string;
};

export const maintenancePageTranslation: MaintenancePageTranslation = {
  defaultMessage: 'Maintenance work in progress. We apologize for the inconvenience.',
  expectedCompletion: 'Expected completion:',
  maintenanceWork: 'Maintenance Work',
  thankYouMessage: 'Thank you for your patience. System will be back soon.',
};
